// The pre-order page with the two-version offer, on templates/page.preorder.json
// (sections/preorder-offer.liquid). A fork of founders-preorder.js (Route B): the render, the
// size switch, drag to turn, the phone layout, the country picker, the notify form and the
// checkout hand off are the same. What is new:
//   two versions   Founders Edition (one Shopify variant, inventory = the editions left,
//                  overselling off, the size as a line item property) while any are left,
//                  then the standard pre-order (one variant per size)
//   the last few   an order can only take the Founders Editions that are left; past that the
//                  page offers standard pre-orders for the rest
//   sold out       the standard pre-order becomes the main offer and the mirror chrome bead
//                  set add-on appears
//   price end      after the price end date (New York time) the pre-order price line goes and
//                  the page shows the product price, which Shopify Flow changes at that moment
//   live stock     the editions left are re-read from Shopify every 30 seconds and after every
//                  cart change (Section Rendering API), never a number made up on the page
//   currencies     every amount is in the visit's currency with its mark (A$232), formatted by
//                  the rules of snippets/money.liquid; changing the country reloads the page
//                  through Shopify's localization form, so Shopify prices it in that currency
//   the cart       every change goes to Shopify one at a time, in order, each request numbered,
//                  and only the newest cart Shopify sent back is drawn (31 Oct 2026)
//   refusals       when Shopify refuses an add or a change, its own words show under the add
//                  button and the bag shows Shopify's cart; a size Shopify reports as sold out is
//                  struck through and the add button says Sold out (Dawn's product form pattern)
// Every number the customer pays is Shopify's: prices, the two bracelet discount, inventory.
(() => {
  const $ = id => document.getElementById(id);
  const D = JSON.parse($('offer-data').textContent);
  const W = JSON.parse($('offer-words').textContent);
  const S = D.settings;
  const fill = (s, vars) => String(s).replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const MAX = W.maxPerOrder;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const plural = (n, one, many) => (n === 1 ? one : many);

  // Money in the visit's currency (Will D, 31 Oct 2026: "the currency flag on the price tag, like
  // A$229"). snippets/money.liquid holds the table of marks and gives this visit's entry as
  // D.currency; this follows the snippet's rules exactly: the mark, a whole number when the amount
  // is whole, else its decimals (none for yen and won, three for dinars). Shopify gives every
  // amount in hundredths, whatever the currency's decimals.
  // <money> tests/theme_money.test.mjs runs this function on its own, against the snippet
  function formatMoney(cents, cur) {
    const c = cur || {};
    const n = Math.round(Math.abs(Number(cents) || 0));
    let whole = Math.floor(n / 100), frac = n % 100;
    if (c.decimals === 0) { if (frac >= 50) whole += 1; frac = 0; }
    let s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (frac) s += '.' + String(frac).padStart(2, '0') + (c.decimals === 3 ? '0' : '');
    return (Number(cents) < 0 && n ? '−' : '') + (c.prefix || '') + s + (c.suffix || '');
  }
  // </money>
  const money = cents => formatMoney(cents, D.currency);
  // The settings' US dollar figures in the visit's currency, worked out by the section: the
  // pre-order and retail prices and the amount off each bracelet. Shopify converts a fixed discount
  // at its own rate for the visit (window.Shopify.currency.rate, seen to match /cart.js to the
  // cent), so the amount off is worked out again from that rate when the page has it; the
  // section's figure comes from the Founders Edition's rounded price and can be a little out.
  // Once a bag has shown Shopify's own amount off, the page uses that (below).
  const localFigures = local => {
    const out = { ...local };
    try {
      const sc = window.Shopify && window.Shopify.currency, rate = sc && sc.active === D.currency.code ? parseFloat(sc.rate) : NaN;
      if (D.currency.code !== D.shopCurrency && rate > 0) out.eachOff = Math.round(D.settings.eachOff * rate);
    } catch (e) {}
    return out;
  };
  let L = localFigures(D.local);

  // ---------- the price end, in New York time ----------
  // The instant the end date's last minute is over, worked out for America/New_York with its
  // daylight saving, never a fixed UTC offset.
  function zonedToEpoch(date, time, zone) {
    const [y, mo, d] = String(date).split('-').map(Number);
    const [h, mi] = String(time || '23:59').split(':').map(Number);
    const guess = Date.UTC(y, mo - 1, d, h, mi);
    const offsetAt = t => {
      const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date(t)).map(x => [x.type, x.value]));
      return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - t;
    };
    const first = guess - offsetAt(guess);
    return guess - offsetAt(first);                        // second pass settles a daylight saving edge
  }
  let END = NaN;
  try { END = zonedToEpoch(S.endDate, S.endTime, S.timeZone) + 60 * 1000; } catch (e) {}
  const afterEnd = () => S.test === 'after_price_end' || (Number.isFinite(END) && Date.now() >= END);

  // ---------- before pre-orders open: a countdown, nothing can be bought ----------
  let START = NaN;
  try { if (S.startDate) START = zonedToEpoch(S.startDate, S.startTime || '08:00', S.timeZone); } catch (e) {}
  const beforeStart = () => S.test === 'before_sale_start' || (S.test !== 'waitlist_day' && Number.isFinite(START) && Date.now() < START);
  // Waitlist day: from the start until pre-orders open to everyone, the page is frosted until the
  // email someone joined with is found on the waitlist (the gate, at the end of this file).
  let PUBLIC = NaN;
  try { if (S.publicDate) PUBLIC = zonedToEpoch(S.publicDate, S.publicTime || '08:00', S.timeZone); } catch (e) {}
  const PASS = 'deeds-waitlist-pass';
  let passed = false;
  const hasPass = () => { if (passed) return true; try { return !!localStorage.getItem(PASS); } catch (e) { return false; } };
  const waitlistDay = () => S.test === 'waitlist_day'
    || (S.test !== 'before_sale_start' && Number.isFinite(START) && Date.now() >= START && Number.isFinite(PUBLIC) && Date.now() < PUBLIC);
  const gated = () => waitlistDay() && !hasPass();
  // The limited release (Theme settings, Release, "Limited") lasts until the opening: from the start
  // the home page is the whole pre-order page, gated on waitlist day, open after (Will D, 1 Nov 2026).
  const teaser = () => S.mode !== 'full' && beforeStart();
  const startDay = (zone = S.timeZone) => (Number.isFinite(START)
    ? new Intl.DateTimeFormat('en-GB', { timeZone: zone, day: 'numeric', month: 'long' }).format(new Date(START))
    : 'soon');
  const startTime = (zone = S.timeZone) => {
    if (!Number.isFinite(START)) return '';
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: 'numeric', minute: '2-digit', hour12: true })
      .formatToParts(new Date(START)).map(x => [x.type, x.value]));
    if (p.minute === '00' && p.hour === '12') return (p.dayPeriod || '').toLowerCase() === 'am' ? 'midnight' : 'midday';
    return (p.minute === '00' ? p.hour : `${p.hour}:${p.minute}`) + (p.dayPeriod || '').toLowerCase();
  };

  // ---------- the offer: Shopify's products ----------
  let F = { ...D.founders };                               // { id, price, available, left }
  let STD = D.standard.map(v => ({ ...v }));
  let M = { ...D.mirror };
  // Stock held (Theme settings, Release): the products sit at 0 in Shopify until pre-orders open,
  // and the page shows the Founders Edition as available. Only on a preview that lets a tester add
  // before the opening (a test state) does the page say so, under the add button.
  let stockHeld = !!S.stockHeld;
  const sizeKey = v => (/-tbc$/.test(v.sku) ? 'TBC' : v.option);
  const SIZES = STD.map(v => ({ key: sizeKey(v), label: v.option, render: sizeKey(v) === 'TBC' ? 'M' : v.option }));
  const sizeOf = key => SIZES.find(s => s.key === key);
  const stdVariant = key => STD.find(v => sizeKey(v) === key);
  const stdKeyOf = id => { const v = STD.find(x => x.id === id); return v ? sizeKey(v) : null; };
  const foundersOpen = () => S.test === 'founders_sold_out' ? false
    : S.test === 'founders_available' ? true
    : !!F.available && F.left > 0;
  const foundersLeft = () => (S.test === 'founders_available' ? Math.max(F.left, 1) : F.left);
  // What the page shows as the price. In the after-price-end test it shows the retail price
  // setting (in the visit's currency); live, always the product's own price, which is what
  // checkout charges.
  const shownPrice = p => (S.test === 'after_price_end' ? L.retail : p);
  const foundersPrice = () => shownPrice(F.price);
  const standardPrice = () => shownPrice((stdVariant('S') || STD[0]).price);
  const mainPrice = () => (foundersOpen() ? foundersPrice() : standardPrice());

  let warned = '';
  function checkPrices() {
    if (S.test !== 'live') return;
    const want = afterEnd() ? S.retailPrice : S.preorderPrice;
    const msgs = [];
    const p = priced();
    // the settings are US dollars, so the products are checked against them in US dollars only
    if (D.currency.code === D.shopCurrency) {
      if (F.price !== want) msgs.push(`Founders Edition is ${money(F.price)} in Shopify, the setting says ${money(want)}`);
      STD.forEach(v => { if (v.price !== want) msgs.push(`pre-order ${v.option} is ${money(v.price)} in Shopify, the setting says ${money(want)}`); });
      if (M.price !== S.mirrorPrice) msgs.push(`Mirror chrome bead set is ${money(M.price)} in Shopify, the setting says ${money(S.mirrorPrice)}`);
      if (p.reported && p.configured && p.reported !== p.configured) msgs.push(`Shopify takes ${money(p.reported)} off ${p.n} bracelets, the setting says ${money(p.configured)}`);
    }
    if (!pending && p.n >= 2 && !p.reported) msgs.push(`Shopify reports no two bracelet price for ${p.n} bracelets`);
    const msg = msgs.join('; ');
    if (msg && msg !== warned) console.warn('[pre-order] Prices disagree: ' + msg + '. Checkout charges the Shopify price.');
    warned = msg;
  }

  // ---------- saved in this browser: the country (the size always starts at S) ----------
  const KEY = 'deeds-preorder-offer-v1';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const saved = load();
  let country = typeof saved.country === 'string' ? saved.country : '';
  let picked = !!saved.picked;                             // the visitor chose a country in the menu
  let active = sizeOf('S') ? 'S' : SIZES[0].key;        // every visit opens on size S, whatever was picked last time
  // Back from a change of country (Shopify's localization form reloads the page in that country's
  // currency): the same size as before, and the country menu in view.
  const BACK = 'deeds-preorder-back';
  let back = null;
  try { back = JSON.parse(sessionStorage.getItem(BACK)); sessionStorage.removeItem(BACK); } catch (e) {}
  if (back && Date.now() - back.t < 120000 && sizeOf(back.active)) active = back.active; else back = null;
  function save() { try { localStorage.setItem(KEY, JSON.stringify({ active, country, picked })); } catch (e) {} }

  // ---------- rehearsal (preview themes only): the bag kept in this browser ----------
  // Theme setting "Rehearsal", honoured only with a test state. While stock is held Shopify
  // refuses every add, so the rehearsal answers the cart calls itself, in Shopify's shape, and
  // the checkout button stops where Shopify's checkout would open.
  const REH = !!S.rehearsal;
  const REH_KEY = 'deeds-rehearsal-cart';
  let fake = { items: [] };
  try { fake = JSON.parse(sessionStorage.getItem(REH_KEY)) || fake; } catch (e) {}
  const priceOf = id => (id === F.id ? F.price : id === M.id ? M.price : ((STD.find(v => v.id === id) || {}).price || 0));
  // a line's picture, from the offer data (the variant's image, else the product's, else the poster)
  const imageOf = id => (id === F.id ? F.image : id === M.id ? M.image : (STD.find(v => v.id === id) || {}).image) || D.media.poster;
  function fakeCart(url, body) {
    const path = url.replace(/\.js$/, '');
    if (path === D.routes.add && body) {
      for (const it of body.items || []) {
        const props = it.properties || {}, key = it.id + ':' + JSON.stringify(props);
        let l = fake.items.find(i => i.key === key);
        if (!l) {
          // the fields Shopify's /cart.js gives a line that the bag reads, pictures included
          l = { key, variant_id: it.id, quantity: 0, properties: props, original_price: priceOf(it.id), image: imageOf(it.id), featured_image: { url: imageOf(it.id), alt: '' } };
          fake.items.unshift(l);
        }
        l.quantity += it.quantity;
      }
    } else if (path === D.routes.change && body) {
      const l = fake.items.find(i => i.key === body.id);
      if (l) l.quantity = body.quantity;
    }
    fake.items = fake.items.filter(i => i.quantity > 0);
    // Shopify's figures for each line, in this visit's currency (a bag kept from a visit in another
    // currency is priced again): with two or more bracelets, the two bracelet price takes the
    // amount off each bracelet, as a line level discount
    const bracelet = id => id === F.id || STD.some(v => v.id === id);
    const n = fake.items.reduce((a, l) => a + (bracelet(l.variant_id) ? l.quantity : 0), 0);
    fake.items.forEach(l => {
      const off = n >= 2 && bracelet(l.variant_id) ? L.eachOff : 0;
      l.original_price = priceOf(l.variant_id);
      l.final_price = l.original_price - off;
      l.original_line_price = l.quantity * l.original_price;
      l.final_line_price = l.quantity * l.final_price;
      l.line_level_total_discount = l.quantity * off;
      l.line_level_discount_allocations = off ? [{ amount: l.quantity * off, discount_application: { type: 'automatic', title: W.lines.discount } }] : [];
    });
    fake.currency = D.currency.code;
    try { sessionStorage.setItem(REH_KEY, JSON.stringify(fake)); } catch (e) {}
    const sum = k => fake.items.reduce((a, l) => a + l[k], 0);
    return JSON.parse(JSON.stringify({ ...fake, original_total_price: sum('original_line_price'), total_price: sum('final_line_price'), cart_level_discount_applications: [] }));
  }

  // ---------- the cart ----------
  let cart = REH ? fakeCart('') : D.cart && Array.isArray(D.cart.items) ? D.cart : { items: [] };
  const isFounders = l => l.variant_id === F.id;
  const isStandard = l => stdKeyOf(l.variant_id) !== null;
  const isMirror = l => l.variant_id === M.id;
  const ours = () => (cart.items || []).filter(l => isFounders(l) || isStandard(l) || isMirror(l));
  const sumQ = ls => ls.reduce((n, l) => n + l.quantity, 0);
  const foundersQty = () => sumQ(ours().filter(isFounders));
  const standardQty = () => sumQ(ours().filter(isStandard));
  const mirrorQty = () => sumQ(ours().filter(isMirror));
  const bracelets = () => foundersQty() + standardQty();
  const foundersSize = l => {
    const v = l.properties && l.properties.Size;
    return v && v !== 'Not sure yet' ? v : 'TBC';
  };

  // What the order costs. Shopify's automatic discount ("Two bracelet price", the setting's
  // amount off each bracelet when an order has two or more) shows in /cart.js on each bracelet
  // line, as its line level discount: final_line_price under original_line_price (31 Oct 2026,
  // Will D: the bag shows it on the line itself, struck through, as Dawn's cart does). Those are
  // Shopify's figures, in the visit's currency. While a change is on its way to Shopify, the page
  // shows what Shopify will report: the amount off each bracelet when there are two or more.
  let pending = 0;
  // The amount off each bracelet in the visit's currency: Shopify's own, once a bag has shown it,
  // else the section's conversion of the setting
  let shopEachOff = null;
  const eachOff = () => (shopEachOff !== null ? shopEachOff : L.eachOff);
  const eachPrice = () => mainPrice() - eachOff();          // a bracelet's price in an order of two or more
  const isBracelet = l => isFounders(l) || isStandard(l);
  function learn(c) {
    const l = (c.items || []).find(i => isBracelet(i) && i.quantity > 0 && i.final_line_price < i.original_line_price);
    if (l) shopEachOff = Math.round((l.original_line_price - l.final_line_price) / l.quantity);
  }
  // one line's price before and after the discount, and the discount's name for its tag
  function lineFigures(l) {
    if (pending || l._est) {
      const unit = typeof l.original_price === 'number' ? l.original_price : priceOf(l.variant_id);
      const original = unit * l.quantity, off = isBracelet(l) && bracelets() >= 2 ? eachOff() * l.quantity : 0;
      return { original, final: original - off, titles: off ? [W.lines.discount] : [] };
    }
    const original = l.original_line_price;
    const final = typeof l.final_line_price === 'number' ? Math.min(l.final_line_price, original) : original;
    const titles = [...new Set((l.line_level_discount_allocations || []).filter(a => a.amount > 0)
      .map(a => (a.discount_application && a.discount_application.title) || W.lines.discount))];
    return { original, final, titles: final < original ? (titles.length ? titles : [W.lines.discount]) : [] };
  }
  function priced() {
    const ls = ours(), figs = ls.map(lineFigures);
    const subtotal = figs.reduce((a, f) => a + f.original, 0);
    const lineOff = figs.reduce((a, f) => a + f.original - f.final, 0);
    const cartOff = pending ? 0 : (cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
    const reported = pending ? 0 : lineOff;
    const configured = bracelets() >= 2 ? L.eachOff * bracelets() : 0;   // the setting, converted
    return { n: bracelets(), items: sumQ(ls), subtotal, saving: lineOff + cartOff, reported, configured, total: Math.max(0, subtotal - lineOff - cartOff) };
  }
  learn(cart);

  const route = k => D.routes[k] + '.js';
  const pause = ms => new Promise(r => setTimeout(r, ms));
  // what Shopify said when it refused: its description (add.js, change.js), else its errors
  const saidOf = j => {
    const d = j && (typeof j.description === 'string' && j.description ? j.description : j.errors);
    if (typeof d === 'string') return d;
    if (d && typeof d === 'object') return Object.values(d).flat().filter(x => typeof x === 'string').join(' ');
    return '';
  };
  // One request to Shopify's cart. A 429 (Shopify asking for a slower pace) is tried again twice,
  // after a pause; any other refusal comes back as an error with Shopify's status and words.
  async function api(url, body) {
    if (REH) return fakeCart(url, body);
    for (let i = 0; ; i++) {
      const r = await fetch(url, body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (r.status === 429 && i < 2) { await pause(Math.min(3000, parseFloat(r.headers.get('Retry-After')) * 1000 || 800 * (i + 1))); continue; }
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { const said = saidOf(j), e = new Error(said || j.message || String(r.status)); e.status = r.status; e.said = said; throw e; }
      return j;
    }
  }

  // ---------- the cart queue: one change at a time, and only the newest cart is drawn ----------
  // 31 Oct 2026 (Will D: Remove on several lines in quick succession brought lines back). Every
  // change to Shopify's cart, from the add button, the stepper, Remove, the swap and the bead set,
  // waits for the one before it, so Shopify gets them one at a time and in the order they were made.
  // Every request is numbered as it goes out, and a cart that comes back is kept only if no newer
  // one is in already, so an older answer never repaints over a newer one. While changes wait, the
  // page shows its own sum of them; Shopify's cart is drawn once the last one is back.
  let queue = Promise.resolve(), failed = null;
  let sent = 0;                                            // the number of the newest request out
  let server = null, serverSeq = 0, serverAt = 0;          // Shopify's newest whole cart, its request's number, when it came
  let drawnSeq = 0;                                        // the number of the cart on the page
  const wholeCart = c => !!c && Array.isArray(c.items) && typeof c.total_price === 'number';   // add.js answers with the new lines only
  async function call(url, body) {
    const n = ++sent;
    const c = await api(url, body);
    if (wholeCart(c) && n > serverSeq) { server = c; serverSeq = n; serverAt = Date.now(); }
    return c;
  }
  const readCart = () => call(route('cart'));
  // Shopify's cart as the queue knows it: the one the last change brought back while it is a few
  // seconds old, else read again (another tab may have changed it)
  const knownCart = async () => (server && Date.now() - serverAt < 5000 ? server : readCart());
  function enqueue(job) {
    pending++;
    const run = queue.then(async () => {
      try { await job(); } catch (e) { failed = e; }
      if (--pending) return;                               // more changes wait: keep the page's own sum
      if (failed) {
        const e = failed; failed = null;
        showRefusal(e);
        if (e.status === 422) { await refreshStatus(); tried = true; }   // usually the last Founders Editions just went
        try { await readCart(); } catch (x) {}
        if (pending) return;                               // a change came in meanwhile: it draws when it is back
      }
      if (server && serverSeq >= drawnSeq) { cart = server; drawnSeq = serverSeq; learn(cart); }
      render();
      refreshStatus();
    });
    queue = run.catch(() => {});
    return run;
  }

  // ---------- what Shopify said, under the add button (Dawn's product form pattern) ----------
  // A refused add or change shows Shopify's own words (for example "The product 'The Deeds
  // bracelet, Founders Edition' is already sold out.") in the page's error style under the add
  // button, where a screen reader reads it out, and the bag shows Shopify's cart as it is, so no
  // line ever goes without a word. Anything else that goes wrong shows the page's own line. The
  // next change clears it.
  function showRefusal(e) {
    $('addError').textContent = (e && e.status === 422 && e.said) || W.cartError;
    renderAddMsgs();
  }
  function clearRefusal() {
    if (!$('addError').textContent) return;
    $('addError').textContent = '';
    renderAddMsgs();
  }
  // the optimistic step: the cart as it will be once Shopify agrees
  function bump(id, d, properties, price) {
    const items = (cart.items || []).map(i => ({ ...i }));
    const same = i => i.variant_id === id && JSON.stringify(i.properties || {}) === JSON.stringify(properties || {});
    let l = items.find(same);
    if (!l) { if (d < 0) return; l = { variant_id: id, key: 'pending-' + Math.random(), quantity: 0, original_price: price, properties: properties || {}, image: imageOf(id) }; items.unshift(l); }
    l.quantity += d;
    const unit = typeof l.original_price === 'number' ? l.original_price : price;
    l.original_line_price = l.final_line_price = l.quantity * unit;
    l.line_level_total_discount = 0;
    l._est = true;                                           // the page's figures until Shopify answers
    cart = { ...cart, items: items.filter(i => i.quantity > 0) };
  }

  // ---------- live stock: the Founders Editions left, from Shopify ----------
  // The section re-rendered by Shopify (Section Rendering API) carries the product's inventory
  // as Liquid read it a moment ago.
  let refreshing = null;
  async function refreshStatus() {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      try {
        // the timestamp keeps Shopify's page cache from answering with a copy from a minute ago
        const r = await fetch(`${location.pathname}?section_id=${encodeURIComponent(D.sectionId)}&t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const el = doc.getElementById('offer-data');
        if (!el) return;
        const fresh = JSON.parse(el.textContent);
        F = { ...fresh.founders };
        STD = fresh.standard.map(v => ({ ...v }));
        if (fresh.mirror) M = { ...fresh.mirror };
        if (fresh.settings) stockHeld = !!fresh.settings.stockHeld;
        if (fresh.local && fresh.currency && fresh.currency.code === D.currency.code) L = localFigures(fresh.local);
        render();
      } catch (e) {} finally { refreshing = null; }
    })();
    return refreshing;
  }
  setInterval(() => { if (!document.hidden) refreshStatus(); }, 30000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshStatus(); });

  // ---------- render (spinning bracelet), as Route B ----------
  let held = false, drag = null, target = null, requested = null, seeking = false;
  const canvas = document.querySelector('canvas.spin'), ctx = canvas.getContext('2d');
  const videos = {};
  let cur = null;
  const RENDERS = ['XS', 'S', 'M', 'L'];
  const spinUrl = r => D.media.spins[r] || D.media.fallback;
  const paint = v => { if (v === cur && v.readyState >= 2) ctx.drawImage(v, 0, 0, 1024, 864); };
  RENDERS.forEach(id => {
    const v = document.createElement('video');
    Object.assign(v, { muted: true, loop: true, playsInline: true, preload: 'auto' });
    v.className = 'spin-src'; v.setAttribute('aria-hidden', 'true');
    v.dataset.url = spinUrl(id);
    if (v.requestVideoFrameCallback) {
      const onFrame = () => { paint(v); v.requestVideoFrameCallback(onFrame); };
      v.requestVideoFrameCallback(onFrame);
    }
    v.addEventListener('loadeddata', () => paint(v));
    v.addEventListener('seeked', () => onSeeked(v));
    document.body.append(v);
    videos[id] = v;
  });
  // Each loop is downloaded whole and played from memory (a blob: URL): Safari will not play
  // an mp4 from a host that ignores range requests, and seeking from memory is instant.
  async function loadSpins() {
    const first = videos[sizeOf(active).render];
    const queue = [first, ...Object.values(videos).filter(v => v !== first)];
    for (const v of queue) {
      try {
        const r = await fetch(v.dataset.url);
        if (!r.ok) throw new Error(r.status);
        v.src = URL.createObjectURL(await r.blob());
      } catch (e) {
        v.addEventListener('error', () => { v.src = D.media.fallback; }, { once: true });
        v.src = v.dataset.url;
      }
      if (v === cur && !held) play(v);
    }
  }
  if (!HTMLVideoElement.prototype.requestVideoFrameCallback) (function loop() { if (cur && !cur.paused) paint(cur); requestAnimationFrame(loop); })();
  const poster = new Image();
  poster.onload = () => { if (!cur || cur.readyState < 2) ctx.drawImage(poster, 0, 0, 1024, 864); };
  poster.src = D.media.poster;

  function play(v) {
    if (!v || reduceMotion) return;
    v.muted = true;
    const p = v.play();
    if (p) p.catch(() => {
      const retry = () => { if (v === cur) v.play().catch(() => {}); };
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(ev => window.addEventListener(ev, retry, { once: true, passive: true }));
    });
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !held) play(cur); });

  let warmed = false;
  function warmOthers() {
    if (warmed) return; warmed = true;
    Object.values(videos).filter(v => v !== cur).forEach((v, i) => setTimeout(() => {
      if (v === cur || v.readyState >= 2) return;
      const p = v.play();
      if (p) p.then(() => { if (v !== cur) v.pause(); }).catch(() => {});
    }, 400 * (i + 1)));
  }

  let want = null;
  function showRender(key) {
    const s = sizeOf(key);
    $('renderSize').textContent = s.key === 'TBC' ? W.size.renderLater
      : fill(W.size.render, { size: s.label, range: D.sizes[s.key] || '' });
    const v = videos[s.render];
    want = v;
    if (v === cur) return;
    const prev = cur;
    if (!prev) {
      cur = v; play(v);
      v.addEventListener('playing', warmOthers, { once: true });
      return;
    }
    let done = false;
    const swap = () => {
      if (done || want !== v) return;
      done = true;
      cur = v; paint(v);
      if (held) { v.pause(); seeking = false; target = null; }
      else if (reduceMotion) v.pause();
      else play(v);
      if (prev !== v) prev.pause();
    };
    const seekThenSwap = () => {
      const phase = prev.duration ? ((prev.currentTime + (held ? 0 : 0.05)) % prev.duration) / prev.duration : 0;
      v.addEventListener('seeked', swap, { once: true });
      try { v.currentTime = phase * v.duration; } catch (e) { swap(); }
    };
    if (v.readyState >= 1 && v.duration) seekThenSwap();
    else {
      v.addEventListener('loadedmetadata', seekThenSwap, { once: true });
      const p = v.play(); if (p) p.catch(() => {});
    }
    setTimeout(swap, 500);
  }

  // ---------- drag to turn, as Route B ----------
  const spinWrap = document.querySelector('.spin-wrap');
  const setTime = (v, t) => { if (v.fastSeek) v.fastSeek(t); else v.currentTime = t; };
  function seekTo(t) {
    const v = cur; if (!v || !v.duration) return;
    target = ((t % v.duration) + v.duration) % v.duration;
    if (!seeking) { seeking = true; requested = target; setTime(v, target); }
  }
  function onSeeked(v) {
    paint(v);
    if (v !== cur) return;
    if (held && target !== null && target !== requested) { requested = target; setTime(v, target); }
    else seeking = false;
  }
  function startDrag(x, y) {
    if (!cur || !cur.duration) return;
    drag = { x0: x, y0: y, t0: 0, on: false };
  }
  function moveDrag(x, y) {
    if (!drag) return false;
    if (!drag.on) {
      const dx = x - drag.x0, dy = y - drag.y0;
      if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return false;
      drag.on = true; drag.x0 = x; drag.t0 = cur.currentTime;
      held = true; seeking = false; cur.pause(); spinWrap.classList.add('dragging');
    }
    seekTo(drag.t0 + (x - drag.x0) * cur.duration / Math.max(320, innerWidth));
    return true;
  }
  function endDrag() {
    const d = drag; drag = null;
    if (!d || !d.on) return;
    spinWrap.classList.remove('dragging');
    held = false; target = null; seeking = false;
    play(cur);
  }
  spinWrap.addEventListener('touchstart', e => { if (e.touches.length === 1) startDrag(e.touches[0].clientX, e.touches[0].clientY); else endDrag(); }, { passive: true });
  spinWrap.addEventListener('touchmove', e => { const t = e.touches[0]; if (t && moveDrag(t.clientX, t.clientY)) e.preventDefault(); }, { passive: false });
  spinWrap.addEventListener('touchend', endDrag);
  spinWrap.addEventListener('touchcancel', endDrag);
  spinWrap.addEventListener('pointerdown', e => {
    if (e.pointerType === 'touch' || e.button > 0) return;
    startDrag(e.clientX, e.clientY);
    try { spinWrap.setPointerCapture(e.pointerId); } catch (err) {}
  });
  spinWrap.addEventListener('pointermove', e => { if (e.pointerType !== 'touch') moveDrag(e.clientX, e.clientY); });
  ['pointerup', 'pointercancel'].forEach(ev => spinWrap.addEventListener(ev, e => { if (e.pointerType !== 'touch') endDrag(); }));

  // ---------- phones: the render shrinks as you scroll, as Route B ----------
  const phoneMq = window.matchMedia('(max-width: 900px)');
  const stageCol = document.querySelector('.stage-col'), page = $('page');
  const LABEL = 22, PAD = 6;
  function fitRender() {
    if (!phoneMq.matches) { stageCol.style.height = canvas.style.width = canvas.style.height = page.style.paddingTop = ''; return; }
    const full = Math.min(innerHeight * .46, (innerWidth - 32) * 864 / 1024);
    const min = Math.min(innerHeight * .2, full);
    const h = Math.max(min, full - Math.max(0, scrollY));
    canvas.style.height = h + 'px';
    canvas.style.width = (h * 1024 / 864) + 'px';
    const label = Math.max(LABEL, $('renderFoot').offsetHeight);   // the size line, or the waitlist before pre-orders open
    stageCol.style.height = (h + label + PAD) + 'px';
    page.style.paddingTop = `calc(var(--top) + ${full + label + PAD}px)`;
  }
  window.addEventListener('scroll', fitRender, { passive: true });
  window.addEventListener('resize', () => { fitRender(); fitLine($('addBtn')); tuckIntro(); });
  fitRender();

  function tuckIntro() {
    const intro = document.querySelector('#orderPane .intro'), sub = intro && intro.querySelector('.sub');
    if (!intro || !sub) return;
    intro.style.marginTop = '';
    if (!phoneMq.matches || $('orderPane').hidden || page.classList.contains('is-prelaunch')) return;
    const add = $('addBtn'), bottom = parseFloat(getComputedStyle(add).bottom) || 0;
    // on a preview with the stock held, its line sits on the white over the button
    const note = $('heldNote'), over = note && !note.hidden ? note.offsetHeight + 16 : 0;
    const buttonTop = innerHeight - bottom - add.offsetHeight - over;
    const subTopAtRest = sub.getBoundingClientRect().top + scrollY;
    const gap = buttonTop + 16 - subTopAtRest;
    if (gap > 0) intro.style.marginTop = gap + 'px';
  }

  // ---------- the offer on the page ----------
  let tried = false;                                       // someone tried to add past the Founders Editions left
  function renderOffer() {
    const open = foundersOpen(), price = mainPrice(), left = foundersLeft();
    page.classList.toggle('is-sold-out', !open);
    $('offerTitle').hidden = open;
    $('soldOutPill').hidden = open;
    $('definition').hidden = !open;
    $('numbersNote').hidden = !open && !foundersQty();
    $('cmpSold').hidden = open;
    const each = money(price - eachOff());
    $('priceOne').textContent = money(price);
    if ($('priceEach')) $('priceEach').textContent = fill(W.pair, { each });
    document.querySelectorAll('.js-each').forEach(el => { el.textContent = each; });
    $('cmpPriceLabel').textContent = afterEnd() ? `${money(price)} price` : `${money(price)} pre-order price`;
    $('priceLine').hidden = afterEnd();
    document.querySelectorAll('.js-price-faq').forEach(el => { el.hidden = afterEnd(); });
    // the editions left: the bar fills with the share claimed, the words count what is left, from
    // Shopify's inventory; hidden until the threshold or fewer are left (no percentage early)
    const claimed = Math.max(0, S.cap - left);
    const showBar = open && S.cap > 0 && left <= S.threshold;
    $('claimed').hidden = !showBar;
    if (showBar) {
      const pct = Math.max(claimed ? 1 : 0, Math.min(99, Math.floor(claimed * 100 / S.cap)));
      $('claimedFill').style.width = pct + '%';
      $('claimedLabel').textContent = `${left} of ${S.cap.toLocaleString('en-US')} left`;
    }
    const few = open && left > 0 && left < 10 && !showBar;    // the bar already counts them
    $('fewLeft').hidden = !few;
    if (few) $('fewLeft').textContent = fill(W.few, { left, editions: plural(left, 'Edition', 'Editions') });
  }

  // The last few: an order can hold only the Founders Editions left. Past that, offer a
  // standard pre-order (or swap the extra ones) instead of failing at checkout.
  function renderNotice() {
    const box = $('lastNotice'), text = $('lastNoticeText'), btn = $('standardBtn');
    const fq = foundersQty(), open = foundersOpen(), left = open ? foundersLeft() : 0;
    const price = money(standardPrice());
    let mode = '';
    if (fq > left) mode = 'swap';
    else if (open && tried && fq >= left && bracelets() < MAX) mode = 'add';
    box.hidden = !mode;
    box.dataset.mode = mode;
    if (mode === 'swap') {
      const extra = fq - left;
      text.textContent = left === 0 ? W.last.gone
        : fill(extra === 1 ? W.last.tooManyOne : W.last.tooManyMany, { left, extra, editions: plural(left, 'Edition is', 'Editions are'), price });
      btn.textContent = extra === 1 ? W.last.swapOne : fill(W.last.swapMany, { extra });
    } else if (mode === 'add') {
      text.textContent = fill(W.last.inOrder, { left, editions: plural(left, 'Edition is', 'Editions are'), them: plural(left, 'it', 'them'), price });
      btn.textContent = W.last.addStandard;
    }
  }

  // ---------- the panel ----------
  const sizeButtons = [...document.querySelectorAll('#sizes [data-size]')];
  const laterBtn = $('laterBtn');
  const deciding = () => active === 'TBC';
  const countFor = key => sumQ(ours().filter(l => (isFounders(l) ? foundersSize(l) : isStandard(l) ? stdKeyOf(l.variant_id) : null) === key));
  // A size Shopify reports as sold out. The Founders Edition is one variant, so while it is the
  // offer every size is open; once it has gone (the flip to the standard pre-order comes first),
  // each size is its own standard variant with Shopify's own available.
  const sizeOpen = key => foundersOpen() || !!(stdVariant(key) || {}).available;
  function renderSizes() {
    const later = deciding();
    const firstOpen = sizeButtons.find(b => !b.disabled);
    sizeButtons.forEach(b => {
      const key = b.dataset.size, on = key === active, n = countFor(key), gone = !sizeOpen(key);
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on || (later && b === firstOpen) ? 0 : -1;
      b.querySelector('.n').textContent = n ? '×' + n : '';
      // struck through, as Dawn shows a sold out variant; it can still be chosen, and the add button says Sold out
      b.classList.toggle('is-unavailable', gone);
      const sr = b.querySelector('.size-gone');
      if (sr) sr.textContent = gone ? W.size.gone : '';
    });
    laterBtn.setAttribute('aria-pressed', String(later)); laterBtn.classList.toggle('on', later);
    const laterGone = !sizeOpen('TBC');
    laterBtn.classList.toggle('is-unavailable', laterGone);
    if ($('laterGone')) $('laterGone').textContent = laterGone ? W.size.gone : '';
    const s = sizeOf(active), hint = $('sizeHint');
    hint.textContent = later ? W.size.laterHint : fill(W.size.wrist, { range: D.sizes[s.key] || '' });
    hint.classList.toggle('deciding', later);
    const add = $('addBtn'), n = bracelets(), open = foundersOpen(), soldOut = !sizeOpen(active);
    const founders = open && foundersQty() < foundersLeft();
    const A = W.add;
    if (beforeStart()) add.textContent = fill(W.soon.add, { date: startDay() });
    else if (gated()) add.textContent = W.gate.add;
    else if (n >= MAX) add.textContent = fill(A.full, { max: MAX });
    else if (soldOut) add.textContent = A.soldOut;
    else if (n === 1) add.textContent = fill(W.pairNudge, { each: money(eachPrice()) });
    else if (open && !founders) add.textContent = later ? A.anotherLater : fill(A.another, { size: s.label });   // the last Founders Editions are in the order: pressing it explains
    else if (founders) add.textContent = later ? (n ? A.foundersLaterMore : A.foundersLater) : fill(n ? A.foundersMore : A.founders, { size: s.label });
    else add.textContent = later ? (n ? A.standardLaterMore : A.standardLater) : fill(n ? A.standardMore : A.standard, { size: s.label });
    add.disabled = n >= MAX || beforeStart() || gated() || soldOut;
    fitLine(add);
  }
  // Under the add button: what Shopify said when it refused (above), and on a preview that lets a
  // tester add before the opening while the stock is held, a muted line that says so, since every
  // add then comes back refused. On the live page the stock is held only while the countdown runs.
  const heldShown = () => stockHeld && !beforeStart() && !(Number.isFinite(START) && Date.now() >= START);
  function renderAddMsgs() {
    const box = $('addMsgs'), err = $('addError'), note = $('heldNote');
    if (!box) return;
    err.hidden = !err.textContent;
    note.hidden = !heldShown();
    if (!note.hidden) note.textContent = W.add.held;
    box.hidden = err.hidden && note.hidden;
  }
  function fitLine(el) {
    el.style.fontSize = el.style.whiteSpace = '';
    let px = parseFloat(getComputedStyle(el).fontSize);
    while (el.scrollWidth > el.clientWidth && px > 14) el.style.fontSize = (--px) + 'px';
    if (el.scrollWidth > el.clientWidth) el.style.whiteSpace = 'normal';
  }

  const foundersProps = key => ({ Size: key === 'TBC' ? 'Not sure yet' : sizeOf(key).label });
  function addFounders(key) { addFoundersWith(foundersProps(key)); }
  // add.js answers with the new line only, so each add then reads the whole cart
  function addFoundersWith(props) {
    bump(F.id, +1, props, F.price);
    enqueue(async () => { await call(route('add'), { items: [{ id: F.id, quantity: 1, properties: props }] }); await readCart(); });
  }
  function addStandard(key) {
    const v = stdVariant(key);
    if (!v) return;
    bump(v.id, +1, {}, v.price);
    enqueue(async () => { await call(route('add'), { items: [{ id: v.id, quantity: 1 }] }); await readCart(); });
  }
  // The 5 per order is held here (Shopify has no per order limit without an app); Shopify holds
  // the Founders Edition inventory, so it refuses a Founders Edition that is not there, and the
  // page shows its words.
  function add() {
    const n = bracelets();
    if (beforeStart()) { toast(fill(W.soon.toast, { date: startDay() })); return; }
    if (gated()) { syncGate(); return; }
    if (n >= MAX) { toast(fill(W.add.toastFull, { max: MAX })); return; }
    if (!sizeOpen(active)) return;                         // sold out: the button says so
    clearRefusal();
    if (foundersOpen()) {
      if (foundersQty() >= foundersLeft()) { tried = true; render(); $('lastNotice').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      addFounders(active);
    } else addStandard(active);
    render({ added: true });
  }
  function noticeAction() {
    const mode = $('lastNotice').dataset.mode;
    if (mode === 'add') { if (bracelets() < MAX) { clearRefusal(); addStandard(active); } tried = false; render({ added: true }); return; }
    if (mode === 'swap') {
      // The extra Founders Editions become standard pre-orders of the same sizes, newest lines
      // first. The standard ones go in first, so if Shopify refuses them the order keeps its
      // Founders Editions and the page shows Shopify's words.
      let extra = foundersQty() - (foundersOpen() ? foundersLeft() : 0);
      const swaps = [], adds = [];
      for (const l of ours().filter(isFounders)) {
        if (extra <= 0) break;
        const v = stdVariant(foundersSize(l));
        if (!v) continue;
        const take = Math.min(extra, l.quantity);
        extra -= take;
        swaps.push({ key: l.key, ident: identOf(l), take });
        adds.push({ id: v.id, quantity: take });
      }
      if (!adds.length) return;
      clearRefusal();
      enqueue(async () => {
        await call(route('add'), { items: adds });
        await readCart();
        for (const s of swaps) {
          const items = server.items || [];
          const live = items.find(i => i.key === s.key) || items.find(i => identOf(i) === s.ident);
          if (live) await call(route('change'), { id: live.key, quantity: Math.max(0, live.quantity - s.take) });
        }
      });
      tried = false;
      render();
    }
  }
  // The stepper's minus takes one off a line, Remove takes the whole line. The page takes it off at
  // once (a copy of the cart, never the one Shopify sent), then the change waits its turn in the
  // queue, which finds the line in Shopify's newest cart by its key, or by its variant and
  // properties while Shopify's key for a line just added is not back yet, so quick taps each count
  // once and in order.
  function removeLine(key, all = false) {
    const l = ours().find(i => i.key === key);
    if (!l) return;
    const wasStandard = isStandard(l), ident = identOf(l), q = all ? 0 : l.quantity - 1;
    cart = { ...cart, items: (cart.items || []).map(i => (i === l ? { ...i, quantity: q, _est: true } : i)).filter(i => i.quantity > 0) };
    clearRefusal();
    enqueue(async () => {
      const items = (await knownCart()).items || [];
      const live = items.find(i => i.key === key) || items.find(i => identOf(i) === ident);
      if (!live) return;                                   // gone already (another tab): Shopify's cart is drawn as it is
      const out = await call(route('change'), { id: live.key, quantity: all ? 0 : live.quantity - 1 });
      // a mirror chrome bead set goes with a standard bracelet: never more sets than bracelets
      if (wasStandard) {
        const std = (out.items || []).filter(i => stdKeyOf(i.variant_id) !== null).reduce((n, i) => n + i.quantity, 0);
        const mi = (out.items || []).find(i => i.variant_id === M.id);
        if (mi && mi.quantity > std) await call(route('change'), { id: mi.key, quantity: std });
      }
    });
    tried = false;
    render();
  }
  function addMirror() {
    if (mirrorQty() >= standardQty() || !M.available) return;
    clearRefusal();
    bump(M.id, +1, {}, M.price);
    enqueue(async () => { await call(route('add'), { items: [{ id: M.id, quantity: 1 }] }); await readCart(); });
    render({ added: true });
  }

  // The stepper's plus: one more of the same line, through the same add as the add button, so the
  // 5 per order and the Founders Editions left hold here too.
  function moreOf(key) {
    const l = ours().find(i => i.key === key);
    if (!l) return;
    if (isMirror(l)) { addMirror(); return; }
    if (beforeStart()) { toast(fill(W.soon.toast, { date: startDay() })); return; }
    if (gated()) { syncGate(); return; }
    if (bracelets() >= MAX) { toast(fill(W.add.toastFull, { max: MAX })); return; }
    if (isFounders(l)) {
      if (!foundersOpen() || foundersQty() >= foundersLeft()) { tried = true; render(); $('lastNotice').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      clearRefusal();
      addFoundersWith({ ...(l.properties || {}) });
    } else {
      if (!lineOpen(l)) return;                            // sold out: the plus is off
      clearRefusal();
      addStandard(stdKeyOf(l.variant_id));
    }
    render({ added: true });
  }

  // ---------- your bracelets: the bag, drawn as Shopify themes draw cart lines ----------
  // One row per cart line (Dawn and Horizon's cart items): the product's picture, its name, the
  // size underneath, a quantity stepper and Remove, and the line's price on the right. With two
  // or more bracelets each bracelet line shows its price before the two bracelet price struck
  // through beside the price after it, with the discount's name as a small tag under the size,
  // as Dawn shows a line level discount (Will D, 31 Oct 2026). Rows are kept and updated in
  // place, so the pictures never flash and the stepper keeps its focus.
  const escText = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const glyph = { less: '<path d="M2 6h8"/>', more: '<path d="M2 6h8M6 2v8"/>' };
  const tagIcon = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6.6 1.2H10.8V5.4L5.4 10.8 1.2 6.6z"/><circle cx="8.4" cy="3.6" r=".8"/></svg>';
  // Shopify's CDN sizes a picture from its width parameter
  const sized = (u, w) => { try { const a = new URL(u, location.href); a.searchParams.set('width', w); return a.href; } catch (e) { return u; } };
  const thumbOf = l => sized(l.image || (l.featured_image && l.featured_image.url) || imageOf(l.variant_id), 240);
  const identOf = l => `${l.variant_id}|${JSON.stringify(l.properties || {})}`;
  const titleOf = l => (isMirror(l) ? W.lines.mirror : isFounders(l) ? W.lines.founders : W.lines.standard);
  function sizeLine(l) {
    if (isMirror(l)) return '';
    const k = isFounders(l) ? foundersSize(l) : stdKeyOf(l.variant_id);
    return k === 'TBC' ? W.lines.sizeLater : fill(W.lines.size, { size: sizeOf(k) ? sizeOf(k).label : k });
  }
  const nameOf = l => { const s = sizeLine(l); return s ? `${titleOf(l)}, ${s.charAt(0).toLowerCase()}${s.slice(1)}` : titleOf(l); };
  // a line's variant as Shopify reports it (the Founders Edition's own checks are in moreOf)
  const lineOpen = l => (isMirror(l) ? !!M.available : isFounders(l) || !!(STD.find(v => v.id === l.variant_id) || {}).available);
  const canMore = l => !beforeStart() && !gated() && lineOpen(l) && (isMirror(l) ? mirrorQty() < standardQty() : bracelets() < MAX);

  function buildRow(l) {
    const li = document.createElement('li');
    li.className = 'item';
    const btn = act => `<button class="qty-btn" type="button" data-act="${act}"><svg viewBox="0 0 12 12" aria-hidden="true">${glyph[act]}</svg></button>`;
    li.innerHTML = `<div class="item-media"><img src="${escText(thumbOf(l))}" alt="" width="72" height="72" loading="lazy" decoding="async"></div>
      <div class="item-info"><p class="item-title"></p><p class="item-size"></p><p class="item-discount" hidden>${tagIcon}<span></span></p>
        <div class="item-actions"><div class="qty" role="group">${btn('less')}<span class="qty-n"></span>${btn('more')}</div><button class="item-rm" type="button" data-act="remove"></button></div>
      </div>
      <p class="item-total"><s class="item-was" aria-hidden="true" hidden></s><span class="item-now"></span><span class="sr item-off"></span></p>`;
    li.addEventListener('animationend', e => { e.target.classList.remove('new', 'pop'); });
    return li;
  }
  function updateRow(li, l) {
    const name = nameOf(l), size = sizeLine(l), src = thumbOf(l), img = li.querySelector('img');
    li.dataset.key = l.key;
    li.dataset.ident = identOf(l);
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    li.querySelector('.item-title').textContent = titleOf(l);
    const sz = li.querySelector('.item-size');
    sz.textContent = size; sz.hidden = !size;
    li.querySelector('.qty').setAttribute('aria-label', fill(W.lines.quantity, { item: name }));
    const less = li.querySelector('[data-act="less"]'), more = li.querySelector('[data-act="more"]'), rm = li.querySelector('[data-act="remove"]');
    less.disabled = l.quantity <= 1;                       // one left: Remove takes it off
    less.setAttribute('aria-label', fill(W.lines.less, { item: name }));
    more.disabled = !canMore(l);
    more.setAttribute('aria-label', fill(W.lines.more, { item: name }));
    rm.textContent = W.lines.remove;
    rm.setAttribute('aria-label', fill(W.lines.removeLabel, { item: name }));
    const n = li.querySelector('.qty-n'), was = li.dataset.q;
    n.textContent = l.quantity;
    if (was && Number(was) !== l.quantity) { n.classList.remove('pop'); void n.offsetWidth; n.classList.add('pop'); }
    li.dataset.q = l.quantity;
    // the price: struck through before the discount, beside it after (screen readers hear the
    // price after and the amount off), and the discount's name under the size
    const fig = lineFigures(l), cut = fig.final < fig.original;
    const wasEl = li.querySelector('.item-was'), tag = li.querySelector('.item-discount');
    wasEl.hidden = !cut;
    wasEl.textContent = cut ? money(fig.original) : '';
    li.querySelector('.item-now').textContent = money(fig.final);
    li.querySelector('.item-off').textContent = cut ? ', ' + fill(W.lines.off, { off: money(fig.original - fig.final) }) : '';
    tag.hidden = !cut;
    tag.querySelector('span').textContent = cut ? fig.titles.join(', ') : '';
  }
  let drawn = false, refocus = -1;
  function renderLines() {
    const list = $('lines');
    const order = l => (isFounders(l) ? 0 : isStandard(l) ? 1 : 2);
    const ls = ours().slice().sort((a, b) => order(a) - order(b));
    const rows = new Map([...list.querySelectorAll(':scope > li.item')].map(li => [li.dataset.ident, li]));
    list.querySelectorAll(':scope > li:not(.item)').forEach(li => li.remove());
    const want = ls.map(l => {
      const id = identOf(l);
      let li = rows.get(id);
      if (li) rows.delete(id);
      else { li = buildRow(l); if (drawn) li.classList.add('new'); }
      updateRow(li, l);
      return li;
    });
    rows.forEach(li => li.remove());
    want.forEach((li, i) => { if (list.children[i] !== li) list.insertBefore(li, list.children[i] || null); });
    drawn = true;
    // after Remove, the keyboard lands on the next line's Remove, or on the heading
    if (refocus >= 0) {
      const next = want[Math.min(refocus, want.length - 1)];
      (next ? next.querySelector('[data-act="remove"]') : $('linesLabel')).focus({ preventScroll: true });
      refocus = -1;
    }
    if (!ls.length) list.insertAdjacentHTML('beforeend', `<li class="empty">${escText(W.lines.empty)}</li>`);
  }
  function renderAddon() {
    const show = !foundersOpen() || standardQty() > 0;
    $('addonBox').hidden = !show;
    if (!show) return;
    const btn = $('addonBtn'), sq = standardQty(), mq = mirrorQty(), gone = !M.available;
    btn.disabled = sq === 0 || mq >= sq || gone;
    btn.textContent = sq === 0 ? W.addon.needBracelet : mq >= sq ? W.addon.full : gone ? W.add.soldOut : 'Add a mirror chrome bead set';
  }

  function renderTotals() {
    const p = priced();
    $('orderTotal').textContent = money(p.total);
    $('cartTotal').textContent = p.items ? money(p.total) : '';
    const badge = $('badge');
    badge.textContent = p.items; badge.classList.toggle('on', p.items > 0);
    const blocked = foundersQty() > (foundersOpen() ? foundersLeft() : 0);
    const soon = beforeStart(), shut = gated(), btn = $('checkoutBtn');
    if (!btn.classList.contains('busy')) btn.textContent = soon ? fill(W.soon.checkout, { date: startDay() }) : shut ? W.gate.checkout : W.checkout.button;
    btn.disabled = soon || shut || !(p.n && $('agree').checked && $('agreeAge').checked && sells(countryCode()) && !blocked);
  }

  function render(opts = {}) {
    renderOffer(); renderSizes(); renderAddMsgs(); renderNotice(); renderLines(); renderAddon(); renderTotals(); tuckIntro(); checkPrices();
    if (opts.added) { const b = $('badge'); b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
  }

  function pick(key) {
    if (!sizeOf(key)) return;
    active = key; save(); renderSizes(); tuckIntro(); showRender(active);
  }
  $('sizes').addEventListener('click', e => { const b = e.target.closest('[data-size]'); if (b && !b.disabled) pick(b.dataset.size); });
  $('sizes').addEventListener('keydown', e => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!step) return;
    e.preventDefault();
    const open = sizeButtons.filter(b => !b.disabled);
    if (!open.length) return;
    const i = open.findIndex(b => b.dataset.size === active);
    const j = i < 0 ? (step > 0 ? 0 : open.length - 1) : (i + step + open.length) % open.length;
    pick(open[j].dataset.size);
    open[j].focus();
  });
  laterBtn.addEventListener('click', () => pick('TBC'));
  $('addBtn').addEventListener('click', add);
  $('standardBtn').addEventListener('click', noticeAction);
  $('addonBtn').addEventListener('click', addMirror);
  $('lines').addEventListener('click', e => {
    const b = e.target.closest('button[data-act]'), li = b && b.closest('li.item');
    if (!li || b.disabled) return;
    const key = li.dataset.key;
    if (b.dataset.act === 'less') removeLine(key);
    else if (b.dataset.act === 'more') moreOf(key);
    else {
      if (document.activeElement === b) refocus = [...$('lines').querySelectorAll(':scope > li.item')].indexOf(li);
      removeLine(key, true);
    }
  });
  $('agree').addEventListener('change', renderTotals);
  $('agreeAge').addEventListener('change', renderTotals);
  // "terms of sale" in the tick box opens the full terms in a new tab. Browsers do not tick a box
  // when a link inside its label is clicked; if one ever does, the box goes back to how it was.
  if ($('agreeTerms')) $('agreeTerms').addEventListener('click', () => {
    const box = $('agree'), was = box.checked;
    setTimeout(() => { if (box.checked !== was) { box.checked = was; renderTotals(); } });
  });
  // the comparison's info buttons open a short line under their row
  document.querySelectorAll('.cmp .info').forEach(b => b.addEventListener('click', () => {
    const row = $(b.getAttribute('aria-controls')), open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', String(open));
    row.hidden = !open;
  }));

  // ---------- country, as Route B ----------
  const sel = $('country');
  const norm = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  const AVAIL = new Map(D.available.map(c => [norm(c.name), c.code]));
  const SELLS = new Set(D.available.map(c => c.code));
  const EXCLUDED = new Set(D.excluded);
  const sells = code => !!code && SELLS.has(code);
  const BY_NAME = new Map();
  try {
    const names = new Intl.DisplayNames([D.locale || 'en', 'en'], { type: 'region' });
    [...SELLS, ...EXCLUDED].forEach(code => { try { const n = names.of(code); if (n && n !== code) BY_NAME.set(norm(n), code); } catch (e) {} });
  } catch (e) {}
  (() => {
    const seen = new Set();
    [...sel.options].forEach(o => {
      if (!o.value) return;
      if (/^-+$/.test(o.value.trim()) || seen.has(o.value)) { o.remove(); return; }
      seen.add(o.value);
      o.dataset.code = AVAIL.get(norm(o.value)) || AVAIL.get(norm(o.textContent)) || BY_NAME.get(norm(o.value)) || BY_NAME.get(norm(o.textContent)) || '';
    });
    const coded = new Set([...sel.options].map(o => o.dataset.code).filter(Boolean));
    D.available.filter(c => !coded.has(c.code)).forEach(c => {
      const o = new Option(c.name, c.name); o.dataset.code = c.code;
      const after = [...sel.options].slice(1).find(p => p.textContent.localeCompare(c.name) > 0);
      sel.insertBefore(o, after || null);
    });
  })();
  // The menu opens on the country Shopify priced this visit for (localization.country: from the
  // visitor's IP and market, or the country they last picked), Will D 31 Oct 2026. Someone who
  // picked Somewhere else stays there, and a visit priced for a country we do not ship to opens on
  // Somewhere else, with the notify form.
  let away = '';                                           // the visit's own country, when we do not ship there
  const regionName = code => { try { return new Intl.DisplayNames([D.locale || 'en', 'en'], { type: 'region' }).of(code) || ''; } catch (e) { return ''; } };
  const chosenOption = () => (country ? [...sel.options].find(o => o.value === country) : null);
  const countryCode = () => { const o = chosenOption(); return o && o.dataset.code ? o.dataset.code : country === 'other' ? away : ''; };
  const countryName = () => { const o = chosenOption(); return o && o.dataset.code ? o.textContent.trim() : country === 'other' && away ? regionName(away) : ''; };
  const homeOption = [...sel.options].find(o => o.value && o.dataset.code === D.country);
  country = picked && country === 'other' ? 'other' : homeOption ? homeOption.value : 'other';
  sel.value = country;
  // Shopify shows someone from outside every market the store's backup country, so the page also
  // asks Shopify where the visit comes from (as its geolocation app does), unless the visitor
  // picked a country: from a country we do not ship to, the menu moves to Somewhere else.
  if (!picked && country !== 'other') {
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { headers: { Accept: 'application/json' } })
      .then(r => (r.ok ? r.json() : null))
      .then(j => {
        const ip = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!ip || picked || sells(ip) || country === 'other') return;
        away = String(ip).toUpperCase(); country = 'other'; sel.value = country;
        renderCountry();
      })
      .catch(() => {});
  }

  function renderCountry() {
    const chosen = !!country, code = countryCode(), name = countryName();
    const ok = chosen && sells(code);
    const closed = chosen && !ok && EXCLUDED.has(code);
    $('buyBox').hidden = chosen && !ok;
    $('notifyBox').hidden = !(chosen && !ok && !closed);
    $('notifyClosed').hidden = !closed;
    if (closed) $('notifyClosed').textContent = fill(W.closed, { country: name });
    $('notifyDone').hidden = true;
    if (chosen && !ok && !closed) $('notifyIntro').textContent = name ? fill(W.notify.intro, { country: name }) : W.notify.introOther;
    renderCurrency();
    renderTotals();
  }
  // The line under the prices: the visit's currency and the country the order ships to, and Change,
  // which goes to the country menu (in the limited release, which hides the menu, it opens a picker
  // under the line instead). What the prices include goes by the visit's Shopify market, from the
  // section's one list (Will D, 31 Oct 2026):
  // D.includes is "vat" in the uk and eu markets ("£ prices include VAT, shipping to the ...", and
  // "kr prices include VAT, ..." where the EU market converts to kronor), "duties" in the markets
  // that ship duties paid ("C$ prices include taxes and duties, shipping to ...", and "US$ prices
  // include taxes and duties, ..." where the market is priced in US dollars), and empty for the
  // plain line everywhere else.
  function renderCurrency() {
    const el = $('currencyLine');
    if (!el) return;
    const cur = D.currency, us = cur.code === 'USD' && D.country === 'US';
    const line = D.includes === 'vat' ? W.currency.lineVat : D.includes === 'duties' ? W.currency.lineDuties : W.currency.line;
    const other = D.includes === 'vat' ? W.currency.otherVat : D.includes === 'duties' ? W.currency.otherDuties : W.currency.other;
    const mark = (cur.prefix || cur.suffix || cur.code).trim();
    const code = countryCode(), here = country !== 'other' && code === D.country;
    const where = here ? (W.currency.the.includes(code) ? 'the ' : '') + countryName() : '';
    const text = where ? fill(us ? W.currency.lineUs : line, { mark, country: where })
      : us ? W.currency.otherUs : fill(other, { mark });
    // Change in every mode (Will D, 31 Oct 2026); in the limited release it says whether its picker is open
    const pick = teaser() ? $('currencyPick') : null;
    const opens = pick ? ` aria-controls="currencyPick" aria-expanded="${!pick.hidden}"` : '';
    const change = ` <button class="currency-change" id="currencyChange" type="button" aria-label="${escText(W.currency.changeLabel)}"${opens}>${escText(W.currency.change)}</button>`;
    el.innerHTML = `<span>${escText(text)}</span>${change}`;
  }
  // The limited release hides the country menu with the rest of the order, so there Change opens a
  // small picker under the line (Will D, 31 Oct 2026: someone who had picked another country in the
  // menu had no way back to their own, and every visit with a stale country is the same). It lists
  // the menu's countries, and a pick goes through the menu, so Shopify's localization form takes it
  // and the page comes back priced for that country.
  const quick = $('currencyPick'), quickSel = $('countryQuick');
  function openQuick(open) {
    if (!quick) return;
    if (open && !quickSel.options.length) {
      const first = new Option(sel.options[0].textContent, ''); first.disabled = true; quickSel.add(first);
      [...sel.options].filter(o => o.dataset.code).forEach(o => quickSel.add(new Option(o.textContent, o.dataset.code)));
    }
    if (open) { const o = chosenOption(); quickSel.value = o && o.dataset.code ? o.dataset.code : ''; }
    quick.hidden = !open;
    if ($('currencyChange')) $('currencyChange').setAttribute('aria-expanded', String(open));
    fitLaunch(); measurePin();
    if (open) quickSel.focus({ preventScroll: true });
  }
  if (quickSel) quickSel.addEventListener('change', () => {
    const o = [...sel.options].find(x => x.dataset.code && x.dataset.code === quickSel.value);
    if (!o) return;
    sel.value = o.value;
    sel.dispatchEvent(new Event('change'));
    quickSel.disabled = sel.disabled;                      // on its way through Shopify's form
    if (!sel.disabled) openQuick(false);                   // the country the page is already priced for
  });
  $('currencyLine').addEventListener('click', e => {
    if (!e.target.closest('#currencyChange')) return;
    if (teaser()) { openQuick(!!quick && quick.hidden); return; }
    sel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    sel.focus({ preventScroll: true });
  });
  sel.addEventListener('change', () => {
    country = sel.value; picked = true; away = ''; save();
    const code = countryCode();
    // Another country we ship to: Shopify prices the page in that country's currency, so the page
    // goes through Shopify's localization form and comes back here with the same size and the
    // country menu in view. The bag is Shopify's and comes along; the rehearsal bag is priced
    // again on the way in.
    if (sells(code) && code !== D.country) {
      sel.disabled = true;
      queue.then(() => {
        try { sessionStorage.setItem(BACK, JSON.stringify({ active, t: Date.now() })); } catch (e) {}
        if (localize(code, location.pathname + location.search)) return;
        try { sessionStorage.removeItem(BACK); } catch (e) {}
        sel.disabled = false; renderCountry();
      });
      return;
    }
    renderCountry();
  });

  function localize(code, returnTo) {
    const f = $('localizationForm');
    if (!f) return false;
    f.querySelector('[name="country_code"]').value = code;
    let rt = f.querySelector('[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; f.append(rt); }
    rt.value = returnTo;
    f.submit();
    return true;
  }

  // ---------- notify (we do not ship there yet), as Route B ----------
  function showDone() {
    $('notifyBox').hidden = true;
    const done = $('notifyDone'), name = countryName(); done.hidden = false;
    done.textContent = name ? fill(W.notify.done, { country: name }) : W.notify.doneOther;
  }
  $('notifyForm').addEventListener('submit', e => {
    const input = $('notifyEmail'), email = input.value.trim(), err = $('notifyError');
    err.textContent = '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { e.preventDefault(); err.textContent = W.notify.email; input.focus(); return; }
    input.value = email;
    if ($('notifyWebsite').value) { e.preventDefault(); showDone(); return; }
    const code = countryCode();
    $('notifyTags').value = ['preorder-notify', code ? `country:${code}` : ''].filter(Boolean).join(',');
    picked = true; save();                                 // back from Shopify's form, the menu stays where it is
    const btn = $('notifyBtn'); btn.textContent = W.notify.busy; btn.classList.add('busy');
  });

  // ---------- checkout: Shopify's own ----------
  async function checkout() {
    const code = countryCode();
    if (beforeStart() || gated() || !bracelets() || !sells(code) || !$('agree').checked || !$('agreeAge').checked) return;
    const err = $('checkoutError'); err.textContent = '';
    const btn = $('checkoutBtn');
    btn.disabled = true; btn.textContent = W.checkout.busy;
    try {
      await queue;
      await refreshStatus();                               // the last Founders Editions may have just gone
      if (foundersQty() > (foundersOpen() ? foundersLeft() : 0)) { tried = true; render(); throw new Error('founders'); }
      if (!bracelets()) throw new Error('empty');
      const now = new Date().toISOString();
      // the tick boxes go on the cart in their turn in the queue (nothing is drawn: the page is leaving)
      const update = queue.then(() => call(route('update'), { attributes: { 'Pre order terms agreed': now, 'Age 16 or over confirmed': now } }));
      queue = update.catch(() => {});
      await update;
      if (REH) { btn.disabled = false; btn.textContent = W.checkout.button; renderTotals(); toast(W.rehearsal); return; }
      if (code !== D.country && localize(code, '/checkout')) return;
      window.location.href = '/checkout';
      return;
    } catch (e) {
      if (e.message === 'founders') $('lastNotice').scrollIntoView({ behavior: 'smooth', block: 'center' });
      else err.textContent = e instanceof TypeError ? W.checkout.network : W.checkout.other;
    }
    btn.textContent = W.checkout.button;
    renderTotals();
  }
  $('checkoutBtn').addEventListener('click', checkout);

  window.addEventListener('pageshow', e => {
    if (!e.persisted) return;
    const btn = $('checkoutBtn');
    btn.textContent = W.checkout.button;
    btn.classList.remove('busy');
    $('country').disabled = false;                         // back from the localization form
    render();
    enqueue(readCart);
  });

  // ---------- header + menu, as Route B ----------
  // The menu's items are links to the pages behind it (snippets/offer-header.liquid).
  function setMenu(on) {
    document.body.classList.toggle('menu-open', on); $('menu').classList.toggle('on', on);
    $('menu').setAttribute('aria-hidden', String(!on)); $('menuBtn').setAttribute('aria-expanded', String(on));
  }
  const closeMenu = () => setMenu(false);
  $('menuBtn').addEventListener('click', () => setMenu(!$('menu').classList.contains('on')));
  $('menu').addEventListener('click', e => { if (e.target.closest('[aria-current]')) closeMenu(); });
  if (location.hash === '#orderBlock') setTimeout(() => $('orderBlock').scrollIntoView({ block: 'center' }), 300);
  // In the limited release (Theme settings, Release) there is no bag yet: the cart says when it opens.
  $('cartBtn').addEventListener('click', () => {
    if (teaser()) { toast(fill(W.bagSoon, { date: startDay() })); return; }
    $('orderBlock').scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  let toastT;
  function toast(msg) { const t = $('toast'); t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 3200); }

  // ---------- the countdown ----------
  const pad = n => String(n).padStart(2, '0');
  let wasSoon = beforeStart();
  function tickLaunch() {
    const soon = beforeStart();
    // the limited release ends with the countdown, whatever the page was served with (a copy from
    // before the opening, or a server clock a step behind this one)
    if (S.mode !== 'full' && page.classList.contains('is-teaser') !== soon) {
      page.classList.toggle('is-teaser', soon);
      if (!soon && quick) quick.hidden = true;
      if (!wasSoon) { fitLaunch(); measurePin(); render(); }
    }
    page.classList.toggle('is-prelaunch', soon);
    $('launchBlock').hidden = !soon;
    if (soon) {
      const ms = Number.isFinite(START) ? Math.max(0, START - Date.now()) : 0, t = Math.floor(ms / 1000);
      $('cdD').textContent = pad(Math.floor(t / 86400)); $('cdH').textContent = pad(Math.floor(t / 3600) % 24);
      $('cdM').textContent = pad(Math.floor(t / 60) % 60); $('cdS').textContent = pad(t % 60);
      if (Number.isFinite(START)) $('launchWhen').textContent = fill(W.soon.when, { date: startDay(), time: startTime() });
    }
    if (wasSoon && !soon) { fitLaunch(); measurePin(); render(); refreshStatus(); }    // the moment pre-orders open, without a reload
    wasSoon = soon;
    syncGate();
  }
  // The countdown fills the panel's first screen. On a computer its clock sits level with the
  // bracelet; on a phone it fills what is left under the fixed render.
  function fitLaunch() {
    const block = $('launchBlock');
    block.style.minHeight = block.style.paddingBottom = block.style.paddingTop = '';
    $('detailWrap').style.removeProperty('--extra');
    [block.querySelector('.launch-clock'), $('waitlist')].forEach(el => { el.style.transform = ''; });   // measured at rest; measurePin puts it back
    if (block.hidden) return;
    const panel = $('panel'), pad = parseFloat(getComputedStyle(panel).paddingTop) || 0;
    if (phoneMq.matches) {
      const under = stageCol.getBoundingClientRect().bottom;
      block.style.minHeight = Math.max(320, innerHeight - under - pad - 72) + 'px';
      return;
    }
    block.style.minHeight = Math.max(420, panel.clientHeight - pad) + 'px';   // the whole first screen: nothing below peeks in
    const art = stageCol.querySelector('canvas, video'), clock = block.querySelector('.launch-clock');
    if (!art) return;
    const a = art.getBoundingClientRect(), c = clock.getBoundingClientRect(), w = $('waitlist').getBoundingClientRect();
    const lift = (c.top + w.bottom) / 2 - (a.top + a.height / 2);   // how far the clock and sign up sit below the bracelet's middle
    if (lift > 0) block.style.paddingBottom = Math.min(lift * 2, 240) + 'px';
    else if (lift < 0) block.style.paddingTop = Math.min(-lift * 2, 240) + 'px';
    // Limited release: the details fill one screen under the waitlist, so scrolled to the end the
    // waitlist is at the top, the add button at the foot, the rest spaced between (Will M, 14 Oct).
    // The spare height is shared evenly between the gaps (5: title, prices, price note, ships;
    // details, comparison, sizes), so taller screens breathe without big holes.
    const wrap = $('detailWrap');
    wrap.style.removeProperty('--extra');
    if (page.classList.contains('is-teaser')) {
      // scrolled to the end: the waitlist 12 px under the panel's top (the New York line above it
      // gone), the add button at the panel's foot (its bottom padding, 24 px, CSS), so the span from
      // the waitlist's top to the button's foot is the panel less those two
      const padB = parseFloat(getComputedStyle(panel).paddingBottom) || 0;
      const want = panel.clientHeight - 12 - padB;
      const have = $('waitlist').offsetHeight + 32 + wrap.getBoundingClientRect().height;
      const spare = want - have;
      if (spare > 0) wrap.style.setProperty('--extra', Math.min(spare / 5, 120) + 'px');
    }
  }
  // The countdown holds its place as you scroll, until the next section comes up to just under the
  // sign up; from there everything scrolls together. On a computer the clock and the sign up hold
  // (the panel scrolls) until the Founders Edition title arrives; on a phone the sign up alone holds
  // (the page scrolls) until the sizes arrive.
  let pinGap = 0;
  const pinned = () => (phoneMq.matches ? [$('waitlist')] : [document.querySelector('.launch-clock'), $('waitlist')]);
  const pinScroll = () => (phoneMq.matches ? scrollY : $('panel').scrollTop);
  function measurePin() {
    [document.querySelector('.launch-clock'), $('waitlist')].forEach(el => { el.style.transform = ''; });
    pinGap = 0;
    if ($('launchBlock').hidden) return;
    const next = document.querySelector(phoneMq.matches ? '#orderPane .pick' : '#orderPane .intro');
    pinGap = Math.max(0, next.getBoundingClientRect().top - $('waitlist').getBoundingClientRect().bottom - (phoneMq.matches ? 24 : 32));
    pinWaitlist();
  }
  function pinWaitlist() {
    if (!pinGap) return;
    const y = `translateY(${Math.min(Math.max(pinScroll(), 0), pinGap)}px)`;
    pinned().forEach(el => { el.style.transform = y; });
  }
  window.addEventListener('scroll', pinWaitlist, { passive: true });
  $('panel').addEventListener('scroll', pinWaitlist, { passive: true });
  // The opening time in other cities, under the New York time (a chevron opens it).
  function renderCities() {
    if (!Number.isFinite(START)) { $('tzBtn').hidden = true; return; }
    $('tzList').innerHTML = W.soon.cities.map(([city, zone]) =>
      `<li><span>${city}</span><span>${startDay(zone)}, ${startTime(zone)}</span></li>`).join('');
  }
  renderCities();
  $('tzBtn').addEventListener('click', () => {
    const open = $('tzBtn').getAttribute('aria-expanded') !== 'true';
    $('tzBtn').setAttribute('aria-expanded', String(open)); $('tzList').hidden = !open;
    fitLaunch(); measurePin();
  });
  $('launchMore').addEventListener('click', () => document.querySelector('#orderPane .intro').scrollIntoView({ behavior: 'smooth', block: 'start' }));
  tickLaunch();
  fitLaunch();
  measurePin();                                            // the gap between the two is the same at any scroll
  setInterval(tickLaunch, 1000);
  window.addEventListener('resize', () => { fitLaunch(); measurePin(); });

  // ---------- boot ----------
  // The price end can pass while the page is open: re-render on the minute.
  setInterval(() => renderOffer(), 60000);
  renderCountry();
  // ---------- the waitlist, under the countdown ----------
  // A Shopify customer with email marketing, tagged waitlist. As the deeds.store landing page:
  // whitespace is stripped as you type (mobile autofill adds a trailing space) and the arrow is
  // always tappable, so a bad email explains itself.
  const WL = 'deeds-waitlist';
  const wlGet = k => { try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch (e) { return null; } };
  const wlForm = $('waitlistForm'), wlPill = $('wlPill'), wlInput = $('waitlistEmail'), wlBtn = $('waitlistBtn'), wlErr = $('wlErr');
  const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function waitlistDone(already) {
    wlForm.hidden = true;
    $('waitlistDoneText').textContent = already ? W.waitlist.already : W.waitlist.done;
    $('waitlistDone').hidden = false;
    try { localStorage.setItem(WL, 'joined'); sessionStorage.removeItem(WL); } catch (e) {}
  }
  const pendingWaitlist = wlGet(WL) === 'pending' && /customer_posted=true/.test(location.search);
  if (wlGet(WL) === 'joined' || pendingWaitlist) waitlistDone(false);
  // A signup that went through Shopify's bot check comes back here with customer_posted:
  // count it in Google Analytics too, or the new site under-reports signups.
  if (pendingWaitlist && typeof gtag === 'function') gtag('event', 'waitlist_signup', { path: 'challenge' });
  const wlStrip = () => {
    if (/\s/.test(wlInput.value)) {
      const p = wlInput.selectionStart;
      wlInput.value = wlInput.value.replace(/\s+/g, '');
      try { wlInput.setSelectionRange(Math.min(p, wlInput.value.length), Math.min(p, wlInput.value.length)); } catch (e) {}
    }
    wlBtn.classList.toggle('ready', EMAIL_RX.test(wlInput.value));
    wlPill.classList.remove('invalid'); wlErr.classList.remove('show');
  };
  // The pill says "Join the waitlist" until someone clicks in, then "Email"; empty again on leaving, it goes back.
  const wlInvite = wlInput.placeholder;
  wlInput.addEventListener('focus', () => { wlInput.placeholder = W.waitlist.focus; });
  wlInput.addEventListener('blur', () => { if (!wlInput.value) wlInput.placeholder = wlInvite; });
  wlInput.addEventListener('input', wlStrip);
  wlInput.addEventListener('change', wlStrip);
  function wlError(msg) {
    wlErr.textContent = msg; wlErr.classList.add('show');
    wlPill.classList.remove('invalid'); void wlPill.offsetWidth; wlPill.classList.add('invalid');
  }
  // 2026-10-24: the signup goes to our bridge first. Shopify's own customer form
  // demands a captcha token that only its full-page flow can mint; the background
  // post gets "Missing CAPTCHA token", and the real post that followed landed some
  // people (Instagram's browser, seen 24 Oct) on Shopify's bare error page. The
  // bridge keeps the record, creates the subscribed customer through the Admin API
  // (no captcha), tags it waitlist-preorder, and Klaviyo's Shopify sync does the
  // rest. Shopify's form stays as the fallback if the bridge is unreachable.
  const WL_BRIDGE = 'https://api.deeds.store/api/waitlist';
  async function bridgeSignup(email) {
    const res = await fetch(WL_BRIDGE, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, source: 'preorder' }) });
    if (res.status === 400) return { ok: false, invalid: true };
    if (!res.ok) throw new Error('bridge ' + res.status);
    const j = await res.json().catch(() => ({}));
    return { ok: !!j.success, already: !!j.already };
  }
  // Shopify's customer form, sent in the background (fallback).
  let nativePass = false;
  async function shopifySignup() {
    const res = await fetch(wlForm.action, { method: 'POST', body: new FormData(wlForm), credentials: 'same-origin' });
    // Shopify wants a captcha: either a redirect to /challenge or, since Oct 2026, a
    // 400 "Missing CAPTCHA token" page. Submit the form for real through the submit
    // event, so Shopify's own captcha script can attach its token, and Shopify
    // sends the person back here with customer_posted.
    let captcha = /\/challenge/.test(res.url);
    if (!captcha && res.status === 400) {
      const text = await res.clone().text().catch(() => '');
      captcha = /captcha/i.test(text);
    }
    if (captcha) {
      try { sessionStorage.setItem(WL, 'pending'); } catch (err) {}
      nativePass = true;
      if (wlForm.requestSubmit) wlForm.requestSubmit(); else HTMLFormElement.prototype.submit.call(wlForm);
      return null;
    }
    return res.ok;
  }
  wlForm.addEventListener('submit', async e => {
    if (nativePass) return;   // the fallback's real submit: let Shopify handle it
    e.preventDefault();
    const email = wlInput.value.trim().toLowerCase();
    if (!EMAIL_RX.test(email)) { wlError(email ? W.waitlist.email : W.waitlist.empty); wlInput.focus(); return; }
    if ($('waitlistWebsite').value) { waitlistDone(false); return; }
    wlInput.value = email;
    wlBtn.classList.add('busy');
    try {
      let ok, already = false;
      try {
        const r = await bridgeSignup(email);
        if (r.invalid) { wlError(W.waitlist.email); wlBtn.classList.remove('busy'); wlInput.focus(); return; }
        ok = r.ok; already = r.already;
      } catch (bridgeErr) {
        ok = await shopifySignup();
        if (ok === null) return;
      }
      if (ok) { waitlistDone(already); if (typeof gtag === 'function') gtag('event', 'waitlist_signup'); }
      else wlError(W.waitlist.server);
    } catch (err) { wlError(W.waitlist.network); }
    wlBtn.classList.remove('busy');
  });
  // ---------- waitlist day: the frosted gate ----------
  // The email is checked against the waitlist by our bridge (op 'check') and the page thaws at
  // once; nothing is emailed. Soft by design: if our bridge cannot answer, the person is let in.
  // Function declarations only, with their elements looked up inside, so the countdown's tick
  // can call syncGate before this part of the file has run.
  function syncGate() {
    const gate = $('gate');
    if (!gate) return;
    const on = gated();
    if (on && gate.hidden) {
      gate.hidden = false; gate.classList.remove('thaw');
      document.documentElement.classList.add('is-gated');
    }
    if (on) page.inert = true;
    if (!on && !gate.hidden && !gate.classList.contains('thaw')) thaw();
  }
  function thaw() {
    const gate = $('gate');
    document.documentElement.classList.remove('is-gated');
    page.inert = false;
    gate.classList.add('thaw');
    const done = () => { gate.hidden = true; gate.classList.remove('thaw'); };
    if (reduceMotion) done(); else setTimeout(done, 1100);
    render(); fitLaunch(); measurePin(); refreshStatus();
  }
  function letIn(how) {
    passed = true;
    try { localStorage.setItem(PASS, new Date().toISOString()); } catch (e) {}
    $('gateTitle').textContent = W.gate.welcome;
    $('gateCard').classList.add('in');
    if (typeof gtag === 'function') gtag('event', 'waitlist_gate_pass', { how });
    setTimeout(thaw, reduceMotion ? 0 : 650);
  }
  function gateError(msg) {
    const err = $('gateErr'), pill = $('gatePill');
    err.textContent = msg; err.classList.add('show');
    pill.classList.remove('invalid'); void pill.offsetWidth; pill.classList.add('invalid');
  }
  // A bespoke link from the launch email (Will D, 1 Nov 2026): ?k= carries the person's gate key,
  // the short hash the snapshot holds, never the address. It comes off the address bar at once,
  // the bridge checks it like a typed email, and a hit opens the gate with no typing. Before the
  // opening the pass is kept for the moment the gate rises. A miss changes nothing: the typed gate
  // stays, so a broken link is never worse than no link.
  (() => {
    let key = '';
    try {
      const u = new URL(location.href), k = (u.searchParams.get('k') || '').trim().toLowerCase();
      if (u.searchParams.has('k')) { u.searchParams.delete('k'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); }
      if (/^[0-9a-f]{16}$/.test(k)) key = k;
    } catch (e) {}
    if (!key || hasPass()) return;
    (async () => {
      try {
        const r = await fetch(WL_BRIDGE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'check', key }) });
        if (!r.ok) return;
        const j = await r.json().catch(() => ({}));
        if (!j.found) return;
        if (gated() && $('gate') && !$('gate').hidden) letIn('link');
        else { passed = true; try { localStorage.setItem(PASS, new Date().toISOString()); } catch (e) {} }
      } catch (e) {}
    })();
  })();
  (() => {
    const form = $('gateForm');
    if (!form) return;
    const input = $('gateEmail'), btn = $('gateBtn');
    const strip = () => {
      if (/\s/.test(input.value)) input.value = input.value.replace(/\s+/g, '');
      btn.classList.toggle('ready', EMAIL_RX.test(input.value));
      $('gatePill').classList.remove('invalid'); $('gateErr').classList.remove('show');
    };
    input.addEventListener('input', strip);
    input.addEventListener('change', strip);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (btn.classList.contains('busy')) return;
      const email = input.value.trim().toLowerCase();
      if (!EMAIL_RX.test(email)) { gateError(email ? W.gate.email : W.gate.empty); input.focus(); return; }
      input.value = email;
      btn.classList.add('busy');
      let r = null;
      for (let i = 0; i < 2; i++) {
        try {
          r = await fetch(WL_BRIDGE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'check', email }) });
          if (r.status < 500) break;
        } catch (x) { r = null; }
        await new Promise(s => setTimeout(s, 700));
      }
      btn.classList.remove('busy');
      if (!r || r.status >= 500) { letIn('fallback'); return; }       // our side is down: never lock a real person out
      if (r.status === 400) { gateError(W.gate.email); input.focus(); return; }
      if (r.status === 429) { gateError(W.gate.slow); return; }
      const j = await r.json().catch(() => ({}));
      if (j.found) letIn('found');
      else {
        gateError(W.gate.missing); input.focus();
        if (typeof gtag === 'function') gtag('event', 'waitlist_gate_miss');
      }
    });
    syncGate();
    if (!$('gate').hidden && !phoneMq.matches) input.focus({ preventScroll: true });
  })();
  if ($('rehearsalLock')) $('rehearsalLock').addEventListener('click', () => {
    try { localStorage.removeItem(PASS); sessionStorage.removeItem(REH_KEY); } catch (e) {}
    location.reload();
  });

  function readingCheck() {
    const y = phoneMq.matches ? scrollY : $('panel').scrollTop;
    page.classList.toggle('is-reading', y > 24);
  }
  window.addEventListener('scroll', readingCheck, { passive: true });
  $('panel').addEventListener('scroll', readingCheck, { passive: true });
  readingCheck();

  if ($('notifyPosted') && !pendingWaitlist) showDone();
  render();
  showRender(active);
  loadSpins();
  enqueue(readCart);
  // back from a change of country: the country menu, where the visitor left the page (in the
  // limited release, which hides the menu, the line under the prices, where its picker was)
  if (back) setTimeout(() => (teaser() ? $('currencyLine') : sel).scrollIntoView({ block: 'center' }), 300);
  if (document.fonts) document.fonts.ready.then(() => { fitLine($('addBtn')); tuckIntro(); fitLaunch(); measurePin(); });   // the Founders title's font changes the heights
  window.addEventListener('load', () => { fitLaunch(); measurePin(); });
})();
